import { useEffect, useState } from "react";
import { Button, Modal, message } from "antd";
import { Copy } from "@phosphor-icons/react";
import { createPersonalLink } from "../../service/personalStorage";
import { LinkBox, Warning } from "./MyFilesStyled";

const linkUrlForToken = (token) =>
  `${globalThis.location.origin}/my-files/shared/${token}`;

// The "copy internal link" substitute for Share for review (blocked on
// personal documents server-side, see documents/views/document_share.py).
// Generates a fresh link every time it's opened rather than reusing a prior
// one — revoking old links is a manual, deliberate action from this same
// document's menu, not implicit here.
export default function CopyLinkModal({ open, document, onClose }) {
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !document?.id) {
      setLink(null);
      setError("");
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError("");
    createPersonalLink(document.id)
      .then((response) => {
        if (!cancelled) setLink(response?.data);
      })
      .catch((requestError) => {
        if (!cancelled) {
          setError(
            requestError?.response?.data?.error ||
              "Could not create a link for this file."
          );
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, document]);

  const url = link ? linkUrlForToken(link.token) : "";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      message.success("Link copied to clipboard.");
    } catch {
      message.error("Could not copy automatically — copy it manually below.");
    }
  };

  return (
    <Modal
      open={open}
      title="Copy internal link"
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button key="copy" type="primary" icon={<Copy size={16} />} disabled={!url} onClick={handleCopy}>
          Copy link
        </Button>,
      ]}
      destroyOnHidden
    >
      <Warning>
        Anyone signed in to WHG Docs who opens this link can save their own
        copy of &quot;{document?.name}&quot; — to a Matter, or to their own My
        Files. Your original file is never shared or moved.
      </Warning>
      {loading && <div>Generating link…</div>}
      {url && <LinkBox>{url}</LinkBox>}
      {error && (
        <div role="alert" style={{ marginTop: 10, color: "#b42318", fontSize: 13 }}>
          {error}
        </div>
      )}
    </Modal>
  );
}
